import React, { useEffect, useState } from "react";
import "./proyecto.css";
import { getTarjetasInicio } from "../../config/services/strapi/home";
import { getProyectoDetalle } from "../../config/services/strapi/proyecto";
import TextSkeleton from "../../components/Skeleton/TextSkeleton";
import ImageSkeleton from "../../components/Skeleton/ImageSkeleton";

export default function Proyecto() {
  const [heroData, setHeroData] = useState<any>(null);
  const [secciones, setSecciones] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const [tarjetas, proyectoData] = await Promise.all([
          getTarjetasInicio(),
          getProyectoDetalle(),
        ]);

        const tarjetaProyecto = tarjetas.find((t: any) => t.titulo === "PROYECTO");
        setHeroData(tarjetaProyecto);

        const dataOrdenada = proyectoData.sort((a: any, b: any) => a.id - b.id);
        setSecciones(dataOrdenada);
      } catch (error) {
        console.error("Error cargando datos:", error);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  return (
    <>
      <section className="section-proyecto">
        <div className="section-inner-proyecto">
          <div className="col-media-proyecto">
            {loading ? (
              <ImageSkeleton className="h-full" />
            ) : (
              <div
                className="media-cover-proyecto"
                style={{
                  backgroundImage: heroData?.portada?.url ? `url(${heroData.portada.url})` : "none",
                }}
              />
            )}
          </div>
          <div className="col-text-proyecto proyecto">
            {loading ? <TextSkeleton /> : <h1>{heroData?.Titulo || "PROYECTO"}</h1>}
          </div>
        </div>
      </section>

      {(loading ? Array.from({ length: 2 }).map((_, index) => ({ id: `skeleton-${index}`, descripcion: null, portada: null })) : secciones).map((seccion, index) => {
        const esReverse = index % 2 !== 0;

        return (
          <section key={seccion.id} className="section-principal-proyecto">
            <div className={`contenedor-proyecto ${esReverse ? "contenedor-proyecto-reverse" : ""}`}>

              <div className="columna-texto-proyecto">
                <div className="texto-descripcion-proyecto">
                  {loading ? (
                    <TextSkeleton />
                  ) : (
                    seccion.descripcion?.map((block: any, i: number) => {
                      const text = block.children?.map((c: any) => c.text).join("");
                      return text ? <p key={i}>{text}</p> : null;
                    })
                  )}
                </div>
              </div>

              <div className="columna-imagen-proyecto">
                <div className="wrapper-imagen-proyecto">
                  {loading ? (
                    <ImageSkeleton className="h-full" />
                  ) : seccion.portada?.url && (
                    <img
                      src={seccion.portada.url}
                      alt="Proyecto"
                      className="imagen-adaptable-proyecto"
                    />
                  )}
                </div>
              </div>

            </div>
          </section>
        );
      })}
    </>
  );
}